var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { setElementBaseProps } from '../generators/base-props';
import { propReducer } from '../generators/prop-reducer';
import * as StylesGenerators from '../generators/style';
import * as HandlersGenerators from '../generators/handlers';
import * as ButtonGenerators from './generators';
var generators = [
    HandlersGenerators.getOnKeyHandlerProps,
    HandlersGenerators.getOnClickHandlerProps,
    HandlersGenerators.getFocusHandlerProps,
    ButtonGenerators.getSizeProps,
    ButtonGenerators.getVariantProps,
    StylesGenerators.getColorsProps,
    StylesGenerators.getCursorProps,
    StylesGenerators.getMarginProps,
    StylesGenerators.getPaddingProps,
    StylesGenerators.getWidthAndHeightProps,
    StylesGenerators.getShadowProps,
    StylesGenerators.getBordersPros,
    StylesGenerators.getScrollProps,
    StylesGenerators.getTextProps,
];
export function getButtonProps(props, ref, moreGenerators) {
    if (moreGenerators === void 0) { moreGenerators = []; }
    var reduced = propReducer(props, ref, __spreadArray(__spreadArray([], generators, true), moreGenerators, true));
    setElementBaseProps(props, reduced);
    return reduced;
}
